import { UserModel } from "../../../models/user.model";
import {
  IDashboardItemDto,
  DashboardItemStatus,
  DashboardItemType,
} from "../../../services/bpp.webapi/dashboard.client";
import * as helper from "./constructor.helper";
import { EventCase } from "../models/event-case.enum";
import { getEventCase } from "./event-case.logic";
import { IDashboardMessage } from "../models/dashboard-message.interface";
import { ISessionData } from "../models/session-data.interface";
import { Roles } from "../../../models/enums";
import { DashboardColorSelector } from "./dashboard-color.selector";
import { TranslateService } from "@ngx-translate/core";

function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export class ExtendedMessageConstructor {
  user: UserModel;
  dashboardColorSelector: DashboardColorSelector;
  constructor(
    user: UserModel,
    private translationService: TranslateService,
  ) {
    this.dashboardColorSelector = new DashboardColorSelector();
    this.user = user;
  }

  createMessage(s: IDashboardItemDto): IDashboardMessage {
    // const thisIsMe = this.user.role === helper.getCurrentOperatorRole(s);
    const eventCase: EventCase = getEventCase(s);
    let subject, body, confirmed;
    let mr: string;
    this.translationService.get("MR").subscribe((value) => (mr = value));

    switch (eventCase) {
      case EventCase.ClubSubmitFixture:
        subject = `${helper.getCompany(s)} submitted new ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)}`;
        body = `${helper.getPlayers(s)} submitted for ${helper.getCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)}`;
        confirmed = `Submitted by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.ClubSubmitTraining:
        subject = `${helper.getCompany(s)} submitted new ${helper.getMonth(s)} Training Session`;
        body = `${helper.getCompany(s)} submitted ${helper.getMonth(s)} Training session.`;
        confirmed = `Submitted by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.ClubEditApprovedFixture:
        subject = `${helper.getCompany(s)} updated ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)}`;
        body = `${helper.getCompany(s)} updated ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = `Updated by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.ClubEditApprovedTraining:
        subject = `${helper.getCompany(s)} updated ${helper.getMonth(s)} Training Session`;
        body = `${helper.getCompany(s)} updated ${helper.getMonth(s)} Training Session`;
        confirmed = `Updated by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueApproveFixture:
        subject = `${helper.getEventCompany(s)} - ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} confirmed`;
        body = `${helper.getPlayers(s)} selected for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)}`;
        confirmed = `Confirmed by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueApproveTraining:
        subject = `${helper.getEventCompany(s)} new ${helper.getMonth(s)} Training Session notification`;
        body = `${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session confirmed`;
        confirmed = `Confirmed by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueRejectFixture:
        subject = `${helper.getEventCompany(s)}'s ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} Rejected`;
        body = `${helper.getCompany(s)} rejected ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = `Rejected by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueRejectTraining:
        subject = `${helper.getEventCompany(s)}'s ${helper.getMonth(s)} Training Session Rejected`;
        body = `${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session rejected`;
        confirmed = `Rejected by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueApproveFixtureChanges:
        subject = `${helper.getEventCompany(s)}’s updated ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} confirmed`;
        body = `${helper.getEventCompany(s)} updated ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} confirmed ${helper.getPlayers(s)}`;
        confirmed = `Confirmed by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueApproveTrainingChanges:
        subject = `${helper.getEventCompany(s)} updated ${helper.getMonth(s)} Training Session confirmed`;
        body = `${helper.getEventCompany(s)} updated ${helper.getMonth(s)} Training Session confirmed`;
        confirmed = `Confirmed by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.BroadcasterRequestFixture:
        subject = `${helper.getCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} submitted`;
        body = `${helper.getUserAccount(s)} submitted request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterRequestTraining:
        subject = `${helper.getCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session submitted`;
        body = `${helper.getUserAccount(s)} submitted request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session`;
        confirmed = ``;
        break;
      case EventCase.LeagueApproveFixtureRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} approved`;
        body = `${helper.getUserAccount(s)} approved ${helper.getOwnerCompany(s)}’s request for `;
        body += `${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = ``;
        break;
      case EventCase.LeagueApproveTrainingRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session approved`;
        body = `${helper.getUserAccount(s)} approved ${helper.getOwnerCompany(s)}’s request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterEditApprovedFixture:
        subject = `${helper.getCompany(s)} updated request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} submitted`;
        body = `${helper.getUserAccount(s)} updated request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterEditApprovedTraining:
        subject = `${helper.getCompany(s)} updated request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session submitted`;
        body = `${helper.getUserAccount(s)} updated request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session`;
        confirmed = ``;
        break;
      case EventCase.LeagueRejectFixtureRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} rejected`;
        body = `${helper.getUserAccount(s)} rejected ${helper.getOwnerCompany(s)}’s request `;
        body += `for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = ``;
        break;
      case EventCase.LeagueRejectTrainingRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session rejected`;
        body = `${helper.getUserAccount(s)} rejected ${helper.getOwnerCompany(s)}’s request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session`;
        confirmed = ``;
        break;
      case EventCase.LeagueCreateInterview:
        subject = `${helper.getCompany(s)} submitted new ${helper.getInterviewDate(s)} ${s.interviewTypeName} notification`;
        body = `${helper.getInterviewName(s)} submitted for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = `Submitted by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueUpdateInterview:
        subject = `${helper.getCompany(s)} updated  ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        body = `${helper.getCompany(s)} updated ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = `Submitted by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.BroadcasterRequestInterview:
        subject = `${helper.getCompany(s)} request for ${helper.getInterviewDate(s)} ${s.interviewTypeName} submitted `;
        body = `${helper.getUserAccount(s)} submitted request for  ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterEditApprovedInterview:
        subject = `${helper.getCompany(s)} updated request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        body = `${helper.getUserAccount(s)} updated request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = ``;
        break;
      case EventCase.LeagueApproveInterviewRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getInterviewDate(s)} ${s.interviewTypeName} approved`;
        body = `${helper.getUserAccount(s)} approved ${helper.getOwnerCompany(s)}'s request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = ``;
        break;
      case EventCase.LeagueRejectInterviewRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getInterviewDate(s)} ${s.interviewTypeName} rejected`;
        body = `${helper.getUserAccount(s)} rejected ${helper.getOwnerCompany(s)}'s request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterWithdrawnFixture:
        subject = `${helper.getCompany(s)} request for ${helper.getEventCompany(s)}'s ${helper.getIcsTypeText(s)} withdrawn`;
        body = `${helper.getUserAccount(s)} withdrew request for ${helper.getEventCompany(s)}'s ${helper.getIcsTypeText(s)}`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterWithdrawnTraining:
        subject = `${helper.getCompany(s)} request for ${helper.getEventCompany(s)}'s ${helper.getMonth(s)} Training Session withdrawn`;
        body = `${helper.getUserAccount(s)} withdrew request for ${helper.getEventCompany(s)}'s ${helper.getMonth(s)} Training Session`;
        confirmed = ``;
        break;
      case EventCase.BroadcasterWithdrawnInterview:
        subject = `${helper.getCompany(s)} request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}  withdrawn`;
        body = `${helper.getUserAccount(s)} withdrew request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = ``;
        break;
      case EventCase.LeagueUnRejectFixtureRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} for ${mr} ${helper.getMrText(s)} un-rejected`;
        body = `${helper.getUserAccount(s)} un-rejected ${helper.getOwnerCompany(s)}’s request `;
        body += `for ${helper.getEventCompany(s)}’s ${helper.getIcsTypeText(s)} Match Round ${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = `Un-rejected by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueUnRejectTrainingRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session un-rejected`;
        body = `${helper.getUserAccount(s)} un-rejected ${helper.getOwnerCompany(s)}’s request for ${helper.getEventCompany(s)}’s ${helper.getMonth(s)} Training Session`;
        confirmed = `Un-rejected by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueUnRejectInterviewRequest:
        subject = `${helper.getOwnerCompany(s)} request for ${helper.getInterviewDate(s)} ${s.interviewTypeName} un-rejected`;
        body = `${helper.getUserAccount(s)} un-rejected ${helper.getOwnerCompany(s)}'s request for ${helper.getInterviewDate(s)} ${s.interviewTypeName}`;
        confirmed = `Un-rejected by ${helper.getUserAccount(s)}`;
        break;
      case EventCase.LeagueUpdateFixture:
        subject = `${helper.getEventCompany(s)}'s ${helper.getIcsTypeText(s)} for ${mr}${helper.getMrText(s)} updated`;
        body = `${helper.getUserName(s)} updated ${helper.getEventCompany(s)}'s ${helper.getIcsTypeText(s)} ${mr}${helper.getMrText(s)} ${helper.getPlayers(s)}`;
        confirmed = `Updated by ${helper.getUserAccountWithoutBrackets(s)}`;
        break;
      default:
        return undefined;
    }

    const clubId =
      isNullOrUndefined(s.userCompanyId) || isNaN(Number(s.userCompanyId))
        ? undefined
        : parseInt(s.userCompanyId, 10);
    const result: IDashboardMessage = {
      subject,
      body,
      confirmed,
      data: this.getSessionData(s),
      date: s.updatedOn,
      account: helper.getUserAccount(s),
      avatar: helper.getAvatar(clubId),
      clubId,
      color: this.dashboardColorSelector.getDashboardColor(s),
    };

    return result;
  }

  getSessionData(s: IDashboardItemDto): ISessionData {
    const data: ISessionData = {
      title: helper.getMatchInfo(s),
      updatedOn: s.updatedOn,
      arrival: s.arrival,
      start: s.start,
      location: s.location,
      languages: s.languages,
      attendees: s.attendees,
      match: s.matchData,
      eventId: s.eventId,
      isRejected: s.dashboardItemStatus === DashboardItemStatus.Rejected,
      showLeagueNote:
        s.dashboardItemStatus === DashboardItemStatus.Rejected &&
        (s.dashboardItemType === DashboardItemType.FixtureEvent ||
          s.dashboardItemType === DashboardItemType.TrainingEvent) &&
        s.leagueNote !== undefined &&
        s.leagueNote !== null &&
        s.leagueNote !== "",
      leagueNote: s.leagueNote,
      showBpp:
        this.user.role === Roles.Admin ||
        this.user.role === Roles.League ||
        this.user.role === Roles.Club,
      userRole: this.user.role,
      interviewee: s.interviewee,
      monthId: s.elementId,
      broadcasterDeadline: s.broadcasterDeadline,
      isNonLiveFixtureEvent: s.isNonLiveFixtureEvent,
    };

    return data;
  }
}
